import { render } from "./ProfitLossReport.vue?vue&type=template&id=71f6d597&scoped=true"
import script from "./ProfitLossReport.vue?vue&type=script&lang=js"
export * from "./ProfitLossReport.vue?vue&type=script&lang=js"

import "./ProfitLossReport.vue?vue&type=style&index=0&id=71f6d597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f6d597"]])

export default __exports__